const conf = {
  SERVER_URL: "https://api.khebrat.app",
  // SERVER_URL: "http://localhost:3500",
};

export default conf;
